<template>
  <div class="skeleton-screen">
    <div class="skeleton-screen__line skeleton-screen__line--short" />
    <div class="skeleton-screen__line" />
    <div class="skeleton-screen__line" />
  </div>
</template>

<script>
export default {
  name: "SkeletonScreen"
}
</script>

<style lang="scss" scoped>
.skeleton-screen {
  display: flex;
  flex-direction: column;
  padding-bottom: $spacing-48;

  &__line {
    width: 100%;
    height: $spacing-16;
    margin-bottom: $spacing-16;

    background: linear-gradient(90deg, #f1f6f4 0%, rgba(241, 246, 244, 0.5) 100%);

    background-color: rgba(241, 246, 244, 0.5);

    background-size: spacing(320px) 100%;
    border-radius: spacing(3px);

    animation: skeleton-loading 1.5s linear infinite;

    &--short {
      width: 80%;
      height: spacing(24px);
    }
  }
}

@keyframes skeleton-loading {
  0% {
    background-position: spacing(-320px) 0;
  }

  100% {
    background-position: calc(spacing(320px) + 100%) 0;
  }
}
</style>
